import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getPrecedures = async () => {
  const builder = new UrlBuilder(`/get-procedures`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const verifyProcedurePermit = async (payload) => {
  const builder = new UrlBuilder(`/verify-procedure-permit`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getZoneList = async () => {
  const builder = new UrlBuilder(`/procedures/get-zones`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getPrecinctOfAddress = async (payload) => {
  const builder = new UrlBuilder(`/procedures/get-precincts`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
